import { render, staticRenderFns } from "./RunningPersonIcon.vue?vue&type=template&id=e6ded04e&scoped=true"
import script from "./RunningPersonIcon.vue?vue&type=script&lang=js"
export * from "./RunningPersonIcon.vue?vue&type=script&lang=js"
import style0 from "./RunningPersonIcon.vue?vue&type=style&index=0&id=e6ded04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ded04e",
  null
  
)

export default component.exports